module.exports = __webpack_public_path__ + "img/load4.9ded4ecc.png";